/**
 * Rate producers for the metric registry. The implementations live in
 * `@ripenn/visibility-scoring` (packages/visibility-scoring/src/rates.ts)
 * so mcp-core, the CLI and the Temporal worker compose rates the same
 * way the webapp does. This module keeps the `@/lib/metrics/rates`
 * import path.
 */
export {
  meanOf,
  mentionRateFromCounts,
  ratePct,
  ratio,
  roundHalfUp,
  shareOfMentions,
  shareOfVoiceFromPrompts,
  weightedMean,
  type MentionCounts,
  type WeightedValue,
} from "@ripenn/visibility-scoring";
